var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSafe0)",
    d: "M4.714 7.988c0 .588.72 7.929 7.286 12.155c6.565-4.226 7.285-11.567 7.285-12.155C16.911 6.146 13.44 5.61 12 5.571c-1.44.039-4.912.575-7.286 2.417"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C195E",
    d: "M5.571 8.563c0 .514.634 6.994 6.429 10.723c5.794-3.729 6.428-10.205 6.428-10.723c-2.096-1.629-5.16-2.1-6.428-2.135c-1.269.035-4.333.506-6.429 2.135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#053275",
    d: "M6.428 9.133c0 .45.549 6.064 5.572 9.295c5.022-3.231 5.571-8.845 5.571-9.295c-1.817-1.41-4.47-1.817-5.571-1.847c-1.102.03-3.755.437-5.572 1.847"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#084784",
    d: "M7.285 9.707c0 .381.467 5.13 4.715 7.864c4.247-2.734 4.714-7.483 4.714-7.864C15.175 8.516 12.93 8.164 12 8.143c-.93.025-3.176.373-4.715 1.564"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005E9B",
    d: "M8.571 10.564c0 .279.339 3.733 3.429 5.722c3.09-1.989 3.428-5.443 3.428-5.722C14.314 9.698 12.677 9.45 12 9.428c-.678.018-2.315.27-3.429 1.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007DB7",
    d: "M9.428 11.143c0 .201.257 2.794 2.572 4.285c2.314-1.491 2.571-4.084 2.571-4.285c-.84-.656-2.061-.845-2.571-.857c-.51.012-1.732.201-2.572.857"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSafe1)",
    d: "m13.658 10.371l-.921.24c-.167-.437-.515-.608-.926-.608c-.407 0-.879.197-.879.655c0 .459.716.63 1.35.806c1.436.373 1.539 1.007 1.539 1.53c0 .527-.33 1.684-2.01 1.684c-1.341 0-1.95-.844-2.087-1.268c.244-.056.771-.189.921-.24c.103.437.515.767 1.166.767c.656 0 1.007-.244 1.007-.703s-.351-.656-1.17-.848c-1.517-.438-1.62-.875-1.62-1.642c0-.613.429-1.53 1.783-1.53c1.084 0 1.684.772 1.843 1.157z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSafe0",
    x1: 4.868,
    x2: 17.995,
    y1: 8.096,
    y2: 13.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8E93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSafe1",
    x1: 13.843,
    x2: 9.887,
    y1: 12.797,
    y2: 12.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8A888B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F1EAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#736B69"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafe);
export default __webpack_public_path__ + "static/media/safe.61b43e122c033894cb98d3d4fe541600.svg";
export { ForwardRef as ReactComponent };